import { Button } from '@/components/ui/button.tsx';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useQueryClient } from '@tanstack/react-query';

export default function ErrorBoundaryFallback({ error, resetErrorBoundary }: { error: Error, resetErrorBoundary: () => void }) {
    const queryClient = useQueryClient();
    return (
        <div className="min-h-screen flex items-center justify-center p-4 bg-background">
            <Card className="w-full max-w-md">
                <CardHeader>
                    <CardTitle className="text-destructive">Something went wrong</CardTitle>
                    <CardDescription>An unexpected error occurred while loading the application.</CardDescription>
                </CardHeader>
                <CardContent className="space-y-4">
                    <p className="text-sm text-muted-foreground border-l-2 border-destructive pl-4">
                        {error.message}
                    </p>
                    <div className="flex justify-end space-x-2">
                        <Button
                            variant="outline"
                            onClick={() => {
                                queryClient.clear();
                                resetErrorBoundary();
                            }}
                        >
                            Try again
                        </Button>
                        <Button
                            variant="default"
                            onClick={() => {
                                queryClient.clear();
                                window.location.href = '/';
                            }}
                        >
                            Go Home
                        </Button>
                    </div>
                </CardContent>
            </Card>
        </div>
    );

}
